<template>
  <div id="verifyPhonePage">
    <flash-message size="is-size-7"></flash-message>
    <template v-if="!flowDone">
      <form v-if="showUpdatePhoneSuccessMessage" novalidate>
        <p class="has-text-centered is-size-7 disclaimer">Please enter the One Time Pin we sent to your mobile</p>
        <p class="control">
          <input v-model.trim="otp_form.otp" :disabled="sending" class="input hp-input" name="otp"
                 placeholder="One Time Pin"
                 type="text"/>
        </p>
        <p v-if="otp_form.errors.has('otp')" class="help is-danger" v-html="otp_form.errors.get('otp')"></p>
        <p class="control">
          <button
            id="otp_button"
            :class="[{ 'is-loading': sending}, 'button', 'hp-btn-primary', 'is-fullwidth']"
            :disabled="!canSubmitOtp || sending"
            type="submit"
            @click.prevent="submitOTP">VERIFY OTP
          </button>
        </p>
        <p class="control">
          <button
            id="re_enter_mobile"
            :class="['button', 'hp-btn-primary', 'is-fullwidth']"
            :disabled="sending"
            @click.prevent="reEnterMobile">CHANGE MOBILE NUMBER
          </button>
        </p>
        <div v-html="OTP_MESSAGES.CHECK_SPAM.HTML"></div>
      </form>
      <form v-else novalidate>
        <template v-if="canShowEnterMobileScreen">
          <div v-if="smsFailed" v-html="smsFailed"></div>
          <p class="has-text-centered is-size-7 disclaimer">Please enter new mobile number</p>
          <p class="control">
            <vue-phone :phone.sync="mobile" :disabled="sending"/>
          </p>
          <p v-if="form.errors.has('mobile')" class="help is-danger" v-html="form.errors.get('mobile')"></p>
          <!-- links for general terms and privacy policy -->
          <p class="control">
            <button
              id="loginButton"
              :class="[{ 'is-loading': sending}, 'button', 'hp-btn-primary', 'is-fullwidth']"
              :disabled="!canSubmit"
              type="submit"
              @click.prevent="submitRegister">VERIFY MOBILE
            </button>
          </p>
        </template>

        <!-- SEND CODE TO EMAIL SCREEN -->
        <p v-if="canShowSendCodeScreen" class="control has-text-left is-size-7">The mobile number you entered is associated with another profile using email address <b>{{ form.errors.get('conflict') }}</b>. Does this email belong to you?
        </p>
        <p v-if="canShowSendCodeScreen" class="control has-text-left is-size-7">If yes, please confirm the email below to receive a unique code</p>
        <template v-if="canShowSendCodeScreen">
          <p class="control">
            <input v-model.trim="confirm_email" :disabled="sending" class="input hp-input" name="confirm_email"
                   placeholder="Confirm email"
                   type="text"/>
          </p>
          <p v-if="confirm_email_error" class="help is-danger" v-html="confirm_email_error"></p>
        </template>
        <p v-if="canShowSendCodeScreen" class="control">
          <button
            id="sendCodeButton"
            :class="[{ 'is-loading': sending}, 'button', 'hp-btn-primary', 'is-fullwidth']"
            :disabled="sending || !isValidEmail"
            @click.prevent="sendCode">SEND CODE
          </button>
        </p>

        <!-- VERIDY CODE SCREEN -->
        <p v-if="canShowCodeVerifyScreen" class="control has-text-left is-size-7">Please enter the <b>code</b> sent to your email address <b>{{ confirm_email }}</b></p>
        <template v-if="canShowCodeVerifyScreen">
          <p class="control">
            <input v-model.trim="verify_code" :disabled="sending" class="input hp-input" name="verify_code"
                   placeholder="Verify CODE"
                   type="text"/>
          </p>
          <p v-if="verify_code_error" class="help is-danger" v-html="verify_code_error"></p>
        </template>
        <p v-if="canShowCodeVerifyScreen" class="control">
          <button
            id="sendCodeButton"
            :class="[{ 'is-loading': sending}, 'button', 'hp-btn-primary', 'is-fullwidth']"
            :disabled="sending || !isValidCode"
            @click.prevent="verifyCode">VERIFY CODE
          </button>
        </p>

        <p v-if="canShowSendCodeScreen && !canShowCodeVerifyScreen" class="control has-text-left is-size-7 mt-10">If you've captured the number incorrectly, you can press the <b>CHANGE&nbsp;MOBILE&nbsp;NUMBER</b> below</p>
        <p v-if="canShowSendCodeScreen && !canShowCodeVerifyScreen" class="control">
          <button
            id="changeMobileNumberButton"
            :class="[{ 'is-loading': sending}, 'button', 'hp-btn-primary', 'is-fullwidth']"
            :disabled="sending"
            @click.prevent="reEnterMobile">CHANGE MOBILE NUMBER
          </button>
        </p>
      </form>
      <p v-if="smsFailedEmail" class="control has-text-centered has-text-weight-bold is-size-7 lh mt-5">
        {{ smsFailedEmail }}
      </p>
      <router-link :to="{ name: 'UserProfile', params: { uuid } }" class="link--v2">
        Back to My Profile
      </router-link>
    </template>
  </div>
</template>
<script>
/* eslint-disable indent,no-new,no-undef */
import axios from 'axios'
import ApiResource from '@/api/ApiResource'
import FlashMessage from '@/components/FlashMessage'
import {VuePhone} from '@/components'
import {otp_phone_verification} from '@/mixins'

export default {
  name: 'UpdatePhonePage',
  components: {
    FlashMessage,
    VuePhone
  },
  metaInfo: {
    title: 'Hellopeter | Update Phone Number'
  },
  mounted () {
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Update Phone Number'
    })
    window.prerenderReady = true
  },
  mixins: [otp_phone_verification],
  data () {
    return {
      uuid: localStorage.getItem('profile_id'),
      isCodeSendForm: false,
      isCodeVerifyForm: false,
      verify_code: '',
      verify_code_error: '',
      confirm_email: '',
      confirm_email_error: '',
      sending: false,
      mobile: '',
      form: new ApiResource({
        mobile: '',
      }),
      otp_form: new ApiResource({
        mobile: '',
        otp: '',
      }),
      error: false,
      showUpdatePhoneSuccessMessage: false,
      flowDone: false
    }
  },
  computed: {
    canSubmitOtp () {
      const otp = this.otp_form.otp
      return otp.length > 0 && otp.match(/^(\d\s*){6}$/g)
    },
    canSubmit () {
      const mobile = this.mobile
      return typeof mobile !== 'undefined' && mobile.length > 0
    },
    canShowEnterMobileScreen () {
      if (this.form.errors.has('conflict')) {
        return false
      }
      return !(this.isCodeSendForm || this.isCodeVerifyForm)
    },
    canShowSendCodeScreen () {
      return this.form.errors.has('conflict') || this.isCodeSendForm && !this.isCodeVerifyForm
    },
    canShowCodeVerifyScreen () {
      return !this.isCodeSendForm && this.isCodeVerifyForm
    },
    isValidEmail () {
      const email = this.confirm_email
      if (typeof email === 'undefined' || email.length < 3) {
        return false
      }

      const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return regex.test(email)
    },
    isValidCode () {
      const code = this.verify_code
      return code.length > 0 && code.match(/^(\d\s*){6}$/g)
    }
  },
  methods: {
    verifyCode () {
      this.sending = true
      this.resetSmsFailedErr()
      this.verify_code_error = ''
      const payload = {
        verify_code: this.verify_code,
        mobile: this.mobile
      }
      axios.post('/consumer/update-profile/phone/verify-conflict-email-otp', payload)
        .then(() => {
          this.sending = false
          this.showUpdatePhoneSuccessMessage = true
        })
        .catch((error) => {
          this.sending = false

          if ('errorKey' in error.response.data && error.response.data.errorKey === 'sms-send-failed') {
            this.populateSmsFailedErr(error.response.data.traceCode)
            this.isCodeSendForm = false
            this.isCodeVerifyForm = false
          } else if ('errors' in error.response.data && 'verify_code' in error.response.data.errors) {
            this.verify_code_error = error.response.data.errors.verify_code[0]
          }
        })
    },
    sendCode () {
      this.isCodeSendForm = true
      this.sending = true
      this.confirm_email_error = ''
      const payload = {
        confirm_email: this.confirm_email,
        mobile: this.mobile
      }
      axios.post('/consumer/update-profile/phone/confirm-conflict-email', payload)
        .then(() => {
          this.sending = false
          this.isCodeVerifyForm = true
          this.isCodeSendForm = false
          this.form.errors.clear()
        })
        .catch((error) => {
          this.sending = false
          if ('errors' in error.response.data && 'confirm_email' in error.response.data.errors) {
            this.confirm_email_error = error.response.data.errors.confirm_email[0]
          }
        })
    },
    reEnterMobile () {
      this.$router.replace({
        path: this.$route.path,
        query: {t: Date.now()}
      })
    },
    submitRegister () {
      this.form.errors.clear(null)
      this.onCaptchaVerified()
    },
    submitOTP () {
      this.otp_form.errors.clear(null)
      this.onCaptchaVerifiedOtp()
    },
    /**
     * Handle when recaptcha passes
     *
     * @returns {void}
     */
    onCaptchaVerifiedOtp () {
      const self = this
      self.sending = true
      self.otp_form.mobile = this.mobile
      self.otp_form.send('/consumer/update-profile/phone/verify-otp')
        .then(() => {
          self.sending = false
          localStorage.setItem('mobile', this.mobile)
          flash('We have updated your mobile number', 'is-success')
          this.flowDone = true
          setTimeout(() => {
            this.$router.push({
              name: 'UserProfile',
              params: {uuid: this.uuid}
            })
          }, 2000)
        })
        .catch((errors) => {
          console.log('errors', errors)
          self.sending = false
          if ('errors' in errors) {
            Object.assign(self.otp_form.errors, errors)
          } else {
            console.log('errors from otp verify', errors.error)
            flash('There was an error verifying your OTP. Please contact admin@hellopeter.com', 'is-danger')
          }
        })
    },
    /**
     * Handle when recaptcha passes
     *
     * @returns {void}
     */
    onCaptchaVerified () {
      const self = this
      this.resetSmsFailedErr()
      self.sending = true
      self.form.mobile = this.mobile
      self.form.send('/consumer/update-profile/phone/capture')
        .then(() => {
          self.sending = false
          self.showUpdatePhoneSuccessMessage = true
        })
        .catch((errors) => {
          console.log('onCaptchaVerified, errors', errors)
          self.sending = false

          if ('errors' in errors) {
            Object.assign(self.form.errors, errors)
          } else if ('errorKey' in errors && errors.errorKey === 'sms-send-failed') {
            this.populateSmsFailedErr(errors.traceCode)
          } else {
            flash(errors.error, 'is-danger')
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
#verifyPhonePage .control {
  margin-top: 10px;
  margin-bottom: 15px;
}

#verifyPhonePage #loginButton {
  margin-top: 30px;
}

.disclaimer {
  color: #58595B;
  margin-top: 1rem;
}

.help {
  margin-top: -10px;
}

.mt-10 {
  margin-top: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/UpdatePhonePage.vue